import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useWorklogStore } from '../store/worklogStore';

/**
 * 인디공사현황 에이전트 최상단 레이아웃 (기능명세 메인화면 A1-3).
 *
 * 어느 경로로 진입하든(메인홈·딥링크 /workorder 등) 이 레이아웃이 항상 먼저 마운트되므로,
 * 여기서 기준정보(basic-info)를 1회 조회해 worklogStore에 적재한다.
 * load()는 멱등이라 하위 경로 이동으로 재마운트돼도 중복 조회하지 않는다.
 * 화면 자체는 <Outlet/>만 렌더하며, 로딩/에러 표현은 각 하위 화면이 store.status로 처리한다.
 *
 * ⚠️ 이탈 시 reset: 이 레이아웃은 에이전트 하위 메뉴 전체를 감싸므로 하위 메뉴 이동으로는
 * 언마운트되지 않고(캐시 유지), 에이전트를 완전히 벗어날 때만 언마운트된다. 그때 store를
 * 초기화해 status를 'idle'로 되돌린다. reset이 없으면 status가 'ready'로 남아, 메뉴·바로가기로
 * 재진입해도 load()의 멱등 가드에 걸려 basic-info를 다시 조회하지 않는다(새로고침해야만 조회되던 버그).
 * 이로써 "에이전트 진입마다 최초 1회 조회"가 보장된다.
 */
export function WorkLogLayout() {
  const load = useWorklogStore((s) => s.load);
  const reset = useWorklogStore((s) => s.reset);

  useEffect(() => {
    void load();
    return () => reset();
  }, [load, reset]);

  return <Outlet />;
}
